import React, { Component } from 'react'
import * as ROUTES from '../routes/routes';
import { Link } from 'react-router-dom';
import lab1 from '../assets/images/lab1.png';
import delete_icon from '../assets/images/icons/delete-icon.png';

export default class Your_Cart_Box extends Component {
  render() {
    return (
      <>
        <div className="your-cart-box">
            <h2>Your Cart</h2>
            <div className="cart-detail-area">
                <div className="cart-detail-box">
                    <div className="image-box">
                        <img src={lab1} alt="Lab" />
                    </div>
                    <div className="cart-item-box">
                        <p className="cart-item-title">Toprani Advanced Lab Systems</p>
                        <span className="cart-item-detail small-text">Racecourse, Vadodara</span>
                    </div>
                </div>
                <div className="cart-item-listing">
                    <div className="cart-item-listing-col">
                        <p className="item-title">Cbc Haemogrmam Test</p>
                        <span className="item-price">₹310
                            <img className='delete-icon' src={delete_icon} alt="Delete" />
                        </span>
                    </div>
                    <div className="cart-item-listing-col">
                        <p className="item-title">Test 2</p>
                        <span className="item-price">₹310
                            <img className='delete-icon' src={delete_icon} alt="Delete" />
                        </span>
                    </div>
                    <div className="cart-item-listing-col">
                        <p className="item-title">Test 3</p>
                        <span className="item-price">₹310
                            <img className='delete-icon' src={delete_icon} alt="Delete" />
                        </span>
                    </div>
                </div>
                <div className="total-amount-box">
                    <p className="total-amount-title">Total Amount</p>
                    <span className="total-amount">₹930</span>
                </div>
                <Link to={ROUTES.CHECKOUT} className="checkout-btn main-btn">Procceed to Checkout</Link>
            </div>
        </div>
      </>
    )
  }
}
